'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$89() {
  this.bpN = null;
  this.bpO = false;
}
export { $c_Lpresto_PrestoRouter$$anon$89 as $c_Lpresto_PrestoRouter$$anon$89 };
$p = $c_Lpresto_PrestoRouter$$anon$89.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$89;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$89() {
}
export { $h_Lpresto_PrestoRouter$$anon$89 as $h_Lpresto_PrestoRouter$$anon$89 };
$h_Lpresto_PrestoRouter$$anon$89.prototype = $p;
$p.c1 = (function() {
  if ((!this.bpO)) {
    this.bpN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bpO = true;
  }
  return this.bpN;
});
$p.P = (function() {
  return this.c1();
});
var $d_Lpresto_PrestoRouter$$anon$89 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$89, "presto.PrestoRouter$$anon$89", ({
  P6: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$89 as $d_Lpresto_PrestoRouter$$anon$89 };
//# sourceMappingURL=presto.-Presto-Router$$anon$89.js.map
